<template>
  <v-form v-model="formValid">
    <v-container>
      <v-row justify="space-between">
        <v-col cols="6">
          <employe-autocomplete
            v-if="rerenderingField"
            v-model="remplacant"
            :etablissement="etablissement"
            label="Remplaçant"
            required
          />
          <contrat-type-autocomplete
            v-if="rerenderingField"
            v-model="command.type"
            remplacement
            required
            :disabled="!remplacant || remplacant.titulaire"
          />
          <v-switch
            v-model="command.remplaceSurTempsReel"
            :label="
              command.remplaceSurTempsReel
                ? 'Le.a remplacant.e hérite des modifications de planning prévues pour l\'employé.e remplacé.e'
                : 'Le.a remplacant.e hérite des uniquement des heures prévues dans le modèle de planning. Toutes les modifications apportées au planning de l\'employé.e remplacé.e sont ignorées'
            "
          />
        </v-col>
        <v-col cols="6" justify="center">
          <p class="text-center text-body-1">Durée du remplacement</p>
          <v-date-picker
            no-title
            first-day-of-week="1"
            v-model="periodeDeRemplacement"
            range
            :min="minDateRemplacement"
            :max="maxDateRemplacement"
          ></v-date-picker>
        </v-col>
      </v-row>
    </v-container>
  </v-form>
</template>

<script>
import employeAutocomplete from '../employe/employe-autocomplete'
import contratTypeAutocomplete from './contrat-type-autocomplete'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'contrat-de-remplacement-form',
  components: {
    employeAutocomplete,
    contratTypeAutocomplete,
  },
  data: () => ({
    periodeDeRemplacement: [],
    formValid: false,
    numericFieldRule: [(v) => !isNaN(v) || 'Entrer une valeur numérique'],
    command: undefined,
    rerenderingField: true,
  }),
  props: {
    value: {
      type: Object,
      required: true,
    },
    minDateRemplacement: {
      type: String,
      required: true,
    },
    maxDateRemplacement: {
      type: String,
      required: true,
    },
  },
  created() {
    this.reset()
    this.fetchContratTypes()
  },
  computed: {
    ...mapGetters({
      etablissement: 'application/getSelectedEtablissement',
      getEmployeById: 'employe/getEmployeById',
    }),
    remplacant: {
      get() {
        return this.getEmployeById(this.command.remplacantId)
      },
      set(_employe) {
        this.command.remplacantId = _employe.employeId
      },
    },
  },
  watch: {
    value() {
      this.command = this.value
    },
    formValid() {
      this.$emit('formValidity', this.formValid)
    },
    periodeDeRemplacement() {
      if (this.periodeDeRemplacement.length === 2) {
        this.command.dateDebut = this.periodeDeRemplacement[0]
        this.command.dateFin = this.periodeDeRemplacement[1]
      }
    },
    command() {
      this.$emit('input', this.command)
    },
  },
  methods: {
    ...mapActions({
      fetchContratTypes: 'contrat/fetchContratTypes',
    }),
    reset() {
      this.forceRenderFormFieldsAutocomplete()
      this.command = this.value
      this.periodeDeRemplacement[0] = this.minDateRemplacement
      this.periodeDeRemplacement[1] = this.maxDateRemplacement
    },
    async forceRenderFormFieldsAutocomplete() {
      this.rerenderingField = false
      await this.$nextTick()
      this.rerenderingField = true
    },
  },
}
</script>

<style scoped></style>
